function initBabyFieldsValidation() {
    let babynameField = document.querySelector('.product-form.dummy-button form .baby-name-field');
    let babydobField = document.querySelector('.product-form.dummy-button form .baby-dob-field'); 
    
    const errorField = document.querySelector('.baby-error-field'); 
    const babybuyButtons = document.querySelectorAll(".product-form .dummy-buy-btn");    
    const soldout_btn = document.querySelectorAll('.button-add-to-cart');
    
    if (!babynameField || !babydobField || babybuyButtons.length === 0) {
        console.error("Error: Required elements not found.");
        return; 
    }
    const checkFields = () => {
        const isNameEmpty = babynameField.value.trim() === "";
        const isDobEmpty = babydobField.value.trim() === "";
        const soldout_btns = document.querySelectorAll('.button-add-to-cart');
        if (isNameEmpty || isDobEmpty) {                        
            babybuyButtons.forEach((button) =>{
                button.classList.remove('d-none');
                button.classList.add('d-block');                
                errorField.setAttribute("hidden", true);
                if (soldout_btns.length > 0) {
                    soldout_btns.forEach((btn) => {
                      if (btn.textContent.trim() === 'Sold out') { 
                        document.querySelectorAll('.dummy-buy-btn.original').forEach((btn_el) => {
                          btn_el.classList.add('disabled-btn');
                        });
                      }
                    });
                }
            });              
        } else {
            babybuyButtons.forEach((button)=> {
                button.classList.remove('d-block');
                button.classList.add('d-none'); 
                if (soldout_btns.length > 0) {
                    soldout_btns.forEach((btn) => {
                      if (btn.textContent.trim() === 'Sold out') { 
                        document.querySelectorAll('.dummy-buy-btn.original').forEach((btn_el) => {
                          btn_el.classList.remove('disabled-btn');
                        });
                      }
                    });
                  }              
            });
        }
    };

    babynameField.addEventListener('input', checkFields);
    babydobField.addEventListener('input', checkFields);

    babybuyButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            const isNameEmpty = babynameField.value.trim() === "";
            const isDobEmpty = babydobField.value.trim() === "";

            if (isNameEmpty || isDobEmpty) {
                event.preventDefault();
                errorField.removeAttribute("hidden");   
                setTimeout(() => errorField.setAttribute("hidden", true), 3000);            
            }
        });
    });
    checkFields(); 
}

const observer = new MutationObserver(() => {
    if (document.querySelector('.product-form.dummy-button form .baby-name-field')) {
        observer.disconnect(); 
        initBabyFieldsValidation();
    }
});
observer.observe(document.body, { childList: true, subtree: true });
window.initBabyFieldsValidation = initBabyFieldsValidation;